import moment from 'moment'
import React from 'react'
import Text from 'react-text'
import {Consumer} from '../../../context'
import Standards from './standards'
import Items from './items'
import {viewerGuard} from 'helpers/url'

export default function Plan(props) {
  const format = date => moment(date).format('MM/DD/YYYY')
  const {content, items} = props
  const {lessons, standards, resources} = content
  const start = format(props.start)
  const end = format(props.finish)
  return (<Consumer>{context => {
    const {translate, profile, subjects, grades} = context
    const {institution, individual} = profile
    const subject = subjects.find(subject => subject.id == props.subject)
    const grade = grades.find(grade => grade.id == props.grade)
    return (
      <div className="plan">
        <div className="plan-school info">
          <div className="school">
            <label><Text id="school" />:</label>
            <span>{institution.name}</span>
          </div>
          <div className="teacher">
            <label><Text id="teacher" />:</label>
            <span>{`${individual.last_name}, ${individual.first_name}`}</span>
          </div>
        </div>
        <div className="details title">
          <Text id="details-title" />
        </div>
        <div className="plan-date info">
          <div className="date">
            <label><Text id="assigned-date"/>:</label>
            {start == end && (<span>{`${start}`}</span>)}
            {start != end && (<span>{`${start} - ${end}`}</span>)}
          </div>
          {grade && (<div className="grade">
            <label><Text id="grade"/>:</label>
            <span>{grade.name}</span>
          </div>)}
          {subject && (<div className="subject">
            <label><Text id="subject"/>:</label>
            <span>{subject.name}</span>
          </div>)}
        </div>
        {props.title && (<div className="plan-title info">
          <div>
            <label><Text id="content-title" />:</label>
            <span>{props.title}</span>
          </div>
        </div>)}
        {props.unit && (<div className="plan-unit info">
          <div>
            <label><Text id="unit" />:</label>
            <span>{props.unit}</span>
          </div>
        </div>)}
        {lessons && lessons.length > 0 && (<div className="plan-lessons info">
          <div>
            <label><Text id="lessons_label" />:</label>
            <span>
              {lessons.map(lesson => (<div className="lesson" key={lesson.id}>{`${lesson.id}: ${lesson.name}`}</div>))}
            </span>
          </div>
        </div>)}
        {resources && resources.length > 0 && (<div className="plan-resources info">
          <div>
            <label>{context.translate("digital-resources")}:</label>
            <span>
              {resources.map((resource,id) => {
                return (<div className="resource" key={id}><a {...viewerGuard({href: resource.href, target:" _blank"})}>{resource.title}: <span>{resource.href}</span></a></div>)
              })}
            </span>
          </div>
        </div>)}
        {standards && standards.length > 0 && (<Standards standards={standards} />)}
        {items && items.length > 0 && (<Items items={items} />)}
      </div>
    )
  }}</Consumer>)
}
